import React from 'react';

export default class Page6 extends React.Component {

    render() {

        return <div id="region-main-pad">
            <div id="region-main"><span id="user-notifications"/>
                <div className="region-content">
                    <div role="main"><span id="maincontent"/>
                        <section>
                            <div className="">
                                <div className="ilead-rgt people">
                                    <div className="innerpadding">
                                        <div className="ilead-contentarea">
                                            <div className="border_subtitle">Authenticity</div>
                                            <p>Does your body language match what you’re saying? If not, you’re
                                                sending confusing messages which will lead people to conclude
                                                that you’re someone who’s ‘difficult to read’ or ‘not what he
                                                seems’ but this doesn’t mean you have to gesticulate wildly to
                                                ‘act out’ what you’re saying. For example, if you say you’re
                                                willing to help a colleague with a presentation next week, but
                                                slouch in your chair and roll your eyes at the same time,
                                                they’re likely to doubt that you mean what you say!</p>
                                            <div className="border_subtitle">Keep your word</div>
                                            <p>This not only means doing what you said you would. It involves
                                                respecting others by keeping confidential information they may
                                                have divulged, to yourself.</p>
                                            <div className="border_subtitle">Invest time in being organised
                                            </div>
                                            <p>Manage your time so you can honour commitments you have made. Ask
                                                yourself how long it will realistically take you to complete
                                                tasks and agree feasible targets with your colleagues and/or
                                                manager. If you need to reschedule your time, tell others as
                                                soon as possible to not only limit the consequences for them but
                                                prevent them forming a negative impression of you.</p>
                                            <div className="border_subtitle">Do not take advantage/play fair
                                            </div>
                                            <p>It’s quite normal to build close working relationships at work.
                                                Be careful, though, not to use these relationships to gain an
                                                advantage over others. Being open and honest about your dealings
                                                with your colleagues helps to build trust.</p>
                                            <div className="circle_title"><img
                                                src={require('@images/browndot.jpg')}
                                                alt=""/>NEXT STEPS
                                            </div>
                                            <p>You should by now have more of a sense of how to build and
                                                maintain trust. Here are some suggestions about what to do
                                                next:</p>
                                            <div className="border_subtitle">Discuss delivery style with
                                                someone
                                            </div>
                                            <p>Talk about how to build and maintain trust with someone who you
                                                trust, such as your line manager, mentor, coach or colleague.
                                                Think about what you want from this person – do you want a
                                                sounding board? Do you want advice and guidance or do you want
                                                someone to help review and check your progress?</p>
                                            <div className="border_subtitle">Look for opportunities to
                                                practise
                                            </div>
                                            <p>Watch out for opportunities in your current work or elsewhere to
                                                practise some of the tips and exercises that you have picked up
                                                from this tool.</p>
                                            <div className="border_subtitle">Evaluate your relationships</div>
                                            <p>Take some time to consider the most important relationships that
                                                you currently have and the level of trust that you feel exists.
                                                Consider one or two people who you would like to feel more trust
                                                between you and them. For each person think about what you can
                                                work on to build more trust. Use this reflection to help you to
                                                build trust with new people.</p>


                                            <div className="left-btn">
                                                <div onClick={this.props.handleChangePage('Page5')}
                                                     className="button-next-previous-done">&lt;&lt; Previous
                                                </div>
                                            </div>
                                            <div className="right-btn">
                                                <div onClick={this.props.handleChangePage('Page7')}
                                                     className="button-next-previous-done">Next &gt;&gt;</div>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                    </div>
                </div>
            </div>
        </div>;
    }
}